import { useCallback, useEffect, useState } from 'react';
import { reviewService } from './reviewService';

export function useGoogleReviewConfig(clinicId) {
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState({ enabled: false, googleReviewUrl: '' });
  const [clinicName, setClinicName] = useState('');

  const reload = useCallback(async () => {
    if (!clinicId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const { clinicData, config: next } = await reviewService.loadClinicReviewBundle(clinicId);
      setClinicName(clinicData?.name || '');
      setConfig(next);
    } catch {
      setConfig({ enabled: false, googleReviewUrl: '' });
    } finally {
      setLoading(false);
    }
  }, [clinicId]);

  useEffect(() => {
    reload();
  }, [reload]);

  const saveConfig = async ({ enabled, googleReviewUrl }) => {
    const next = await reviewService.saveReviewConfig(clinicId, { enabled, googleReviewUrl });
    setConfig(next);
    return next;
  };

  const isReady = config.enabled && !!config.googleReviewUrl;

  return { loading, config, clinicName, isReady, saveConfig, reload };
}
